import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackslash = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "icon icon-tabler icons-tabler-outline icon-tabler-backslash",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "none",
		d: "M0 0h24v24H0z",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", { d: "M7 5l10 14" })]
});
export default SvgBackslash;
